import { Box } from '@mui/material';
import * as React from 'react';
import { Link as RouterLink,useStaticQuery, graphql } from "gatsby";
import { getSrc } from 'gatsby-plugin-image';

export default function BigBreadcrumb ({ stack })  {
    const current = stack[stack.length - 1];
    stack = [{
        name: 'Home', url: '/'
    }].concat(stack || []);
    const data = useStaticQuery(graphql`
    query BBCQuery {
        allStrapiResortWebsites {
          edges {
            node {
              Rectangle5 {
                url
              }
            }
          }
        }
      }
    `)
    const company = data.allStrapiResortWebsites.edges[0].node
   
    return (
        <Box className="bg-no-repeat bg-contain " sx={{backgroundImage: `url(${company?.Rectangle5.url})`}} >
            <div className="lg:h-[68vh] sm:h-[24vh] h-[14vh]">
                <h1 className="text-center text-white font-semibold text-5xl items-center justify-center lg:pt-48 sm:pt-24 pt-10">{current.name}</h1>
                {/* <nav className=" text-center items-center justify-center">
                    {stack.map((l, i) =>
                        l.url ?
                            <span key={i} className="text-center text-black font-semibold text-3xl items-center justify-center"><RouterLink to={l.url}>{l.name}</RouterLink> /</span>  :
                            <span className='text-center text-black font-semibold text-2xl items-center justify-center' key={i}>{l.name}</span>
                    )}
                </nav> */}
            </div>
        </Box>
    )
}

